import {ContentChildren, Directive, QueryList} from '@angular/core';
import {TableColumnDirective} from './table-column.directive';

@Directive({
    selector: 'tr[tableHeaderRow]',
    standalone: false
})
export class TableHeaderRowDirective {

    @ContentChildren(TableColumnDirective)
    public columnDirectivesQueryList: QueryList<TableColumnDirective>;

}
